export enum WorkspaceGroupDetailViewTab {
  USERS = 'users',
  PERMISSIONS = 'permissions',
}
